"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _exponent = _interopRequireDefault(require("./exponent.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-format/src/precisionPrefix.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-format/src/precisionPrefix.js
// module chunks = 1